import styleInject from './node_modules-style-inject-dist-style-inject.es.js';

var css_248z = ".rbf-bottom-fixed-area {\n  opacity: 1;\n  position: fixed;\n  bottom: 0;\n  will-change: transform;\n  transition: opacity 0.1s ease-out, transform 0.1s ease-out;\n}\n\n.rbf-bottom-fixed-area.rbf-hide {\n  opacity: 0; \n  pointer-events: none;\n}";
styleInject(css_248z);

export { css_248z as default };
//# sourceMappingURL=node_modules-react-bottom-fixed-lib-esm-index.css.js.map
